<template>
  <div class="animated fadeIn reg">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters
              v-model="filterOptions"
              style="margin-right: 45px"
              @click="refresh"
            />
            <DropdownColumns
              :fields="[]"
              class="customize"
              :export-link="exportLink"
              :export-json="exportJson"
              :print-link="printLink"
            />
          </div>
          <div style="overflow:auto" class="mt-2">
            <b-table
              id="cash-register-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :hover="true"
              :striped="true"
              :bordered="true"
              stacked="md"
              v-model="copy"
              :items="productsProvider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
              tbody-tr-class="tr-pointer"
              foot-clone
            >
              <template v-slot:head(act)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(explanations)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(receipts)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(payments)="data">{{
                $t(data.label)
              }}</template>

              <template v-slot:empty="scope">
                <div class="text-center">{{ $t(scope.emptyText) }}</div>
              </template>

              <template v-slot:top-row>
                <td colspan="3" class="text-right">
                  {{ $t("Balance the previous day") }}
                </td>
                <td>{{ round(balancePreviousDay) }}</td>
                <td></td>
              </template>
              <template v-slot:bottom-row>
                <td colspan="3" class="text-right">{{ $t("Subtotal") }}</td>
                <td>{{ round(subtotalIn) }}</td>
                <td>{{ round(subtotalOut) }}</td>
              </template>
              <template v-slot:foot(index)>
                <span></span>
              </template>
              <template v-slot:foot(act)>
                <span></span>
              </template>
              <template v-slot:foot(explanations)>
                <div class="text-right">
                  <strong>{{ $t("Final balance") }}</strong>
                </div>
              </template>
              <template v-slot:foot(receipts)>
                <strong>{{ round(total) }}</strong>
              </template>
              <template v-slot:foot(payments)>
                <span></span>
              </template>

              <template v-slot:cell(payments)="data">{{
                round(data.value)
              }}</template>
              <template v-slot:cell(receipts)="data">{{
                round(data.value)
              }}</template>
            </b-table>
          </div>

          <div v-if="devices && devices.length > 0">
            <div
              class="mb-4 d-flex flex-row justify-content-between align-items-center"
            >
              <div></div>
              <h4 class="text-center">{{ $t("TERMINALS") }}</h4>
              <div></div>
            </div>
            <div class="mt-2">
              <b-table
                id="terminals-device-subtable"
                :busy.sync="isBusy"
                show-empty
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :bordered="true"
                v-model="copy"
                :items="devices"
                :fields="fields"
                :current-page="1"
                :per-page="999"
              >
                <template v-slot:head(act)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(explanations)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(receipts)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(payments)="data">{{
                  $t(data.label)
                }}</template>

                <template v-slot:empty="scope">
                  <div class="text-center">{{ $t(scope.emptyText) }}</div>
                </template>

                <template v-slot:cell(payments)="data">{{
                  round(data.value)
                }}</template>
                <template v-slot:cell(receipts)="data">{{
                  round(data.value)
                }}</template>
              </b-table>
            </div>
          </div>

          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <b-button
                  size="sm"
                  @click.stop="
                    $root.$emit('bv::refresh::table', 'cash-register-table')
                  "
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import timeFormat from "@/shared/timeFormat";

export default {
  name: "cashRegister",
  mixins: [tableMixin],
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters
  },
  data: function() {
    return {
      tableName: "cashRegister",
      filterOptions: [
        {
          field: "company_id",
          multiple: true,
          placeholder: "Company",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "companies",
          hide_select: true,
          filterOptions: ["tenant_id"],
          options: [],
          selected: []
        },
        {
          field: "tenant_id",
          multiple: true,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          hide_select: true,
          filterOptions: ["shopgroup_id", "shop_id"],
          options: [],
          originalOptions: [],
          selected: [],
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map(elem => elem.eid);
            const orig = data.list[1].originalOptions;
            if (
              selected.length == 0 &&
              data.list[1].options.length != orig.length
            ) {
              data.list[1].options = orig;
            } else if (selected.length != 0) {
              data.list[1].options = orig.filter(item => {
                if (selected.indexOf(item.ecompany_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          }
        },

        {
          field: "shopgroup_id",
          multiple: true,
          placeholder: "Shop Group",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shopGroups",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptions: ["shop_id"],
          postIgnore: true,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map(elem => elem.eid);
            const index = 2;
            const orig = data.list[index].originalOptions;
            if (selected.length == 0) {
              data.list[index].options = orig;
            } else {
              data.list[index].options = orig.filter(item => {
                if (selected.indexOf(item.etenant_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          }
        },
        {
          field: "shop_id",
          multiple: false,
          placeholder: "Shop",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shops",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptionsBy: (data, field, fieldValue) => {
            let selectedTenants = [];
            let selectedShopGroups = [];

            if (field == "tenant_id") {
              selectedTenants = fieldValue.map(elem => elem.eid);
            } else {
              selectedTenants = data.list[0].selected.map(elem => elem.eid);
            }
            if (field == "shopgroup_id") {
              selectedShopGroups = fieldValue.map(elem => elem.eshop_ids);
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            } else {
              selectedShopGroups = data.list[2].selected.map(
                elem => elem.eshop_ids
              );
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            }
            const index = 3;
            const orig = data.list[index].originalOptions;

            if (!selectedTenants.length && !selectedShopGroups.length) {
              data.list[index].options = orig;
            } else {
              let tmp = [];

              if (selectedTenants.length) {
                tmp = orig.filter(item => {
                  if (selectedTenants.indexOf(item.etenant_id) > -1) {
                    return true;
                  }
                  return false;
                });
              }

              if (selectedShopGroups.length) {
                if (!selectedTenants.length && !selectedTenants.length) {
                  tmp = orig;
                }
                tmp = tmp.filter(item => {
                  if (selectedShopGroups.indexOf(item.eid) > -1) {
                    return true;
                  }
                  return false;
                });
              }
              data.list[index].options = tmp;
            }
          }
        },
        {
          field: "save_time",
          type: "date",
          opens: "right",
          singleDatePicker: true,
          timePicker: true,
          locale: {
            format: timeFormat.datePickerShort, //format of the dates displayed
            firstDay: 1, //ISO first day of week - see moment documenations for details
            showWeekNumbers: true //show week numbers on each row of the calendar
          },
          selected: {
            startDate: moment(),
            endDate: moment()
          },
          default: {
            startDate: moment(),
            endDate: moment()
          },
          ranges: false
        }
      ],
      isBusy: false,
      fields: [
        {
          key: "index",
          label: "No. Crt",
          sortable: false,
          ignore: true,
          class: "mw-select"
        },
        {
          key: "act",
          label: "Act",
          sortable: false,
          ignore: true,
          class: ""
        },
        {
          key: "explanations",
          label: "Explanations",
          sortable: false,
          ignore: true,
          class: ""
        },
        {
          key: "receipts",
          label: "Receipts",
          sortable: false,
          ignore: true,
          class: ""
        },
        {
          key: "payments",
          label: "Payments",
          sortable: false,
          ignore: true,
          class: ""
        }
      ],
      sortBy: "",
      sortDesc: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      copy: null,
      addLabel: "",

      devices: [],

      balancePreviousDay: 0,
      subtotalIn: 0,
      subtotalOut: 0,
      total: 0
    };
  },
  computed: {
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    exportLink() {
      const apiUrl = this.$store.getters["global/apiUrl"];
      const endpoint = this.$store.getters["cashRegister/endpoint"];

      return `${apiUrl}/${endpoint}?export=xls&lang=${this.lang}`;
    },
    printLink() {
      return "/print/cash-register";
    },
    exportJson() {
      const fields = [];
      this.fields.forEach(item => {
        if (
          typeof item.class != "undefined" &&
          item.class.indexOf("d-none") == -1
        ) {
          let key = item.key;
          if (key != "selected") {
            const efields = ["eshop_id"];

            if (efields.indexOf(key) > -1) {
              key = key.substr(1);
            }

            fields.push(key);
          }
        }
      });

      const paginationData = this.buildPagination();

      paginationData.fields = fields;

      return JSON.stringify(paginationData);
    }
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "cash-register-table");
      this.$root.$emit("bv::refresh::table", "terminals-device-subtable");
    },

    productsProvider(ctx, cbf) {
      const filteredrowsp = [];
      this.provider(ctx, rows => {
        if (rows.length > 0) {
          rows.forEach(row => {
            if (row.subtable == "products") {
              filteredrowsp.push(row);
            }
          });
        }
        cbf(filteredrowsp);
      });
      return null;
    },

    // devicesProvider(ctx, cbf) {
    //   const filteredrowsd = [];
    //   this.provider(ctx, rows => {
    //     if (rows.length > 0) {
    //       rows.forEach(row => {
    //         if (row.subtable == "devices") {
    //           filteredrowsd.push(row);
    //         }
    //       });
    //     }
    //     cbf(filteredrowsd);
    //   });
    //   return null;
    // },

    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = this.buildPagination();

      this.$store
        .dispatch("cashRegister/fetch", paginationData)
        .then(resp => {
          /*
            // hardcoded test response override:
            resp={"success":true,"data":{"cashiers":null,"company":{"eid":"idHLDlcZlgL94MRmVts1dQ","uuid":"04301c5a-6b6c-4694-aaf5-f81bf665498c","name":"DREAM BETTING SRL","cui":"40594816","registration_number":"J40/4671/2019","address":"Bucuresti, sector 2, Calea Mosilor nr. 158, Modul P167, parter","license_number":"Decizia ONJN nr. 815 din 29.03.2019","ticket_footer_text":""},
            "products":[
              {"in":0,"in_tax":0,"out":0,"out_tax":0,"product_desc":"Lotto","product_id":"idHLDlcZlgL94MRmVts1dQ","product_name":"Lotto","product_z_include":true},
              {"in":0,"in_tax":0,"out":0,"out_tax":0,"product_desc":"Online Cash Transactions","product_id":"AV6VmJjVIwFckk0TQYWLkQ","product_name":"OnlineCash","product_z_include":false},
              {"in":0,"in_tax":0,"out":0,"out_tax":0,"product_desc":"Cash operations","product_id":"","product_name":"Cash operations","product_z_include":false},
              {"in":0,"in_tax":0,"out":0,"out_tax":0,"product_desc":"EPOS transactions","product_id":"","product_name":"EPOS transactions","product_z_include":false},
              {"in":42,"in_tax":0,"out":22,"out_tax":0,"product_desc":"Devices","product_id":"","product_name":"Devices","product_z_include":false},
              ],
            "devices":[
              {"in":0,"in_tax":0,"out":0,"out_tax":0,"product_desc":"DTEST Lotto","product_id":"idHLDlcZlgL94MRmVts1dQ","product_name":"Lotto","product_z_include":true},
              {"in":0,"in_tax":0,"out":0,"out_tax":0,"product_desc":"DTEST Online Cash Transactions","product_id":"AV6VmJjVIwFckk0TQYWLkQ","product_name":"OnlineCash","product_z_include":false},
              {"in":0,"in_tax":0,"out":0,"out_tax":0,"product_desc":"DTEST Cash operations","product_id":"","product_name":"Cash operations","product_z_include":false},
              {"in":0,"in_tax":0,"out":0,"out_tax":0,"product_desc":"DTEST EPOS transactions","product_id":"","product_name":"EPOS transactions","product_z_include":false}],
            "shop_balance":4412.73,"total_hold":0,"total_in":0,"total_in_tax":0,"total_out":0,"total_out_tax":0}};
            */

          this.balancePreviousDay = resp.data.shop_balance
            ? resp.data.shop_balance
            : 0;
          this.subtotalIn = resp.data.total_in ? resp.data.total_in : 0;
          this.subtotalOut = resp.data.total_out ? resp.data.total_out : 0;
          this.total =
            this.balancePreviousDay + this.subtotalIn - this.subtotalOut;

          let index = 1;
          const rowsIn = [];
          const rowsOut = [];

          // always display placeholder terminal device totals at very end of products list
          const placeholderIndexValue = 99999; // will be replaced at the end
          const rememberTD = {
            act: this.$t("Monetary"),
            explanations: this.$t("Terminals Deposits"),
            receipts: 0,
            subtable: "products",
            index: placeholderIndexValue
          };
          const rememberTW = {
            act: this.$t("Deposit"),
            explanations: this.$t("Terminals Withdrawals"),
            payments: 0,
            subtable: "products",
            index: placeholderIndexValue
          };

          resp.data.products.forEach(row => {
            let showRow = true;
            let act = this.$t("Monetary");
            let explanations = `${this.$t("Sales revenue")} ${this.$t(
              row.product_desc
            )}`;

            if (row.product_name === "Cash operations") {
              act = this.$t(row.product_name);
              explanations = this.$t("Supply");

              this.total = this.total + row.in;
              this.subtotalIn = this.subtotalIn + row.in;
            }
            if (row.product_name === "EPOS transactions") {
              showRow = false;
            }
            if (row.product_name === "Devices") {
              showRow = false;
              rememberTD.receipts = row.in;
              this.total = this.total + row.in;  // unsure
              this.subtotalIn = this.subtotalIn + row.in; // unsure
            }
            if (row.in === 0) {
              showRow = false;
            }
            if (showRow) {
              rowsIn.push({
                act: act,
                explanations: explanations,
                receipts: row.in,
                subtable: "products",
                index
              });
              index++;
            }
          });
          resp.data.products.forEach(row => {
            let showRow = true;
            let act = this.$t("Payment provision");
            let explanations = `${this.$t("Payment of prizes")} ${this.$t(
              row.product_desc
            )}`;

            if (
              row.product_name === "Cash operations" ||
              row.product_name === "EPOS transactions"
            ) {
              act = this.$t(row.product_name);
              explanations = this.$t("Deposit");

              this.total = this.total - row.out;
              this.subtotalOut = this.subtotalOut + row.out;
            }
            if (row.product_name === "Devices") {
              showRow = false;
              rememberTW.payments = row.out;
              this.total = this.total - row.out;
              this.subtotalOut = this.subtotalOut + row.out;
            }
            if (row.product_name === "EPOS transactions") {
              explanations = this.$t("EPOS Deposit");
            }
            if (row.out === 0) {
              showRow = false;
            }

            if (showRow) {
              rowsOut.push({
                act: act,
                explanations: explanations,
                payments: row.out,
                subtable: "products",
                index
              });
              index++;
            }
          });

          // fill in proper index value
          // rememberTD.index = index;
          // rememberTW.index = index + 1;

          const rows = [...rowsIn, ...rowsOut];

          if (rememberTD.receipts > 0) {
            rememberTD.index = index;
            rows.push(rememberTD);
            index++;
          }
          if (rememberTW.payments > 0) {
            rememberTW.index = index;
            rows.push(rememberTW);
          }

          // reset for devices subtable
          index = 1;
          const drowsIn = [];
          const drowsOut = [];

          if (resp.data.devices && resp.data.devices.length > 0) {
            resp.data.devices.forEach(row => {
              let showRow = true;
              let act = this.$t("Monetary");
              let explanations = `${this.$t("Sales revenue")} ${this.$t(
                row.product_desc
              )}`;

              if (row.product_name === "Cash operations") {
                act = this.$t(row.product_name);
                explanations = this.$t("Supply");
              }
              if (row.in === 0) {
                showRow = false;
              }
              if (showRow) {
                drowsIn.push({
                  act: act,
                  explanations: explanations,
                  receipts: row.in,
                  subtable: "devices",
                  index
                });
                index++;
              }
            });
            resp.data.devices.forEach(row => {
              let showRow = true;
              let act = this.$t("Payment provision");
              let explanations = `${this.$t("Payment of prizes")} ${this.$t(
                row.product_desc
              )}`;

              if (
                row.product_name === "Cash operations" ||
                row.product_name === "EPOS transactions"
              ) {
                act = this.$t(row.product_name);
                explanations = this.$t("Deposit");
              }
              if (row.out === 0) {
                showRow = false;
              }

              if (showRow) {
                drowsOut.push({
                  act: act,
                  explanations: explanations,
                  payments: row.out,
                  subtable: "devices",
                  index
                });
                index++;
              }
            });
          }

          this.devices = [...drowsIn, ...drowsOut];
          // rows.push(...drowsIn, ...drowsOut);

          callback(rows);
        })
        .catch(err => {
          this.$bvToast.toast(
            this.$t(
              err.details && err.details.length ? err.details[0] : err.message
            ),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.type != "date" && item.selected.length && !item.postIgnore) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach(el => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = item.selected.startDate;
            paginationData.dateEnd = item.selected.endDate;
          } else {
            paginationData.dateField = item.field;
            paginationData.dateStart = moment().startOf("month");
            paginationData.dateEnd = moment().endOf("month");
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      return paginationData;
    },
    rowClicked(item, index, event) {},
    redirect() {}
  },
  watch: {
    lang(newValue) {
      this.refresh();
    }
  }
};
</script>

<style lang="scss" scoped>
.reg {
  & /deep/ #cash-register-table tfoot th {
    border: 0 !important;
  }
}
</style>
